import _ from "lodash";
import { restClient } from "../../utils/restClient";
import { path } from "../../api";

const initialState = {};

export default {
  namespaced: true,
  name: "tips",
  state: _.cloneDeep(initialState),
  mutations: {},
  actions: {
    async fetchTips(context, filters = {}) {
      return await restClient(path.admin.tips.base, "GET", null, filters);
    },
    async fetchTipsTotals(context, filters = {}) {
      return await restClient(path.admin.tips.totals, "GET", null, filters);
    },
    async exportTips(context, filters = {}) {
      const response = await restClient(
        path.admin.tips.export,
        "GET",
        null,
        filters
      );
      return { data: response };
    },
  },
};
